import {TranslateService} from "@ngx-translate/core";
import {Component} from "@angular/core";
import {CerbaAuthService, CerbaCookieService, CookieConstantes, UserStore, CorrespondantStore, CorrespondantDto} from "@digicerba/common";
import {Router} from "@angular/router";

@Component({
  selector: 'cm-header',
  templateUrl: './header.component.html',
  host: {'class': 'header'}
})
export class HeaderComponent {

  correspondants: Array<CorrespondantDto> = [];
  selectedValue: CorrespondantDto = null;

  constructor(private cookieService: CerbaCookieService,
              private correspondantStore: CorrespondantStore,
              private translate: TranslateService,
              private router: Router,
              private userStore: UserStore) {
  }

  ngOnInit() {
    //TODO probablement supprimé tout ce contenu issu de l'ancien dev qui n'est pas utilisé aujourd'hui.
    // this.correspondants = this.correspondantStore.getCorrespondants();
    // this.selectedValue = this.correspondantStore.getCorrespondant();
  }

  onCorrespondantChange(newValue: CorrespondantDto) {
    this.selectedValue = newValue;
    this.correspondantStore.setCorrespondant(newValue);
    this.cookieService.removeCoockie(CookieConstantes.COOKIE_CORRESPONDANT);
    this.cookieService.addCoockie(CookieConstantes.COOKIE_CORRESPONDANT, this.correspondantStore.getCorrespondant().code);

    if (this.selectedValue) {
      let tags: any[] = this.selectedValue.tags;

      if (tags.indexOf("en") != -1 && tags.indexOf("fr") == -1) {
        this.translate.use('en');
      }
      else {
        this.translate.use('fr');
      }
    } else {
      this.translate.use('fr');
    }

    window.location.reload(true);
  }

  isTelechargements() {
    return this.router.url.indexOf("/catalogue-telecharger") >= 0;
  }

  isHistorique() {
    return this.router.url.indexOf("/historique-modifications") >= 0;
  }

  isCatalogue() {
    return this.router.url.indexOf("/catalogue-examens") >= 0;
  }

  isSpecific() {
    return this.isTelechargements() || this.isHistorique() || this.isCatalogue();
  }

  isGuest(): boolean {
    let role = this.userStore.getUser().role;
    return role == "INVITE";
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/header/header.component.ts